export function applyMergeFields(
  template: string,
  fields: Record<string, string>
): string {
  if (!template) return '';

  const lookup = new Map<string, string>();
  for (const [key, value] of Object.entries(fields || {})) {
    const normalized = String(key || '').trim().toLowerCase();
    if (!normalized) continue;
    lookup.set(normalized, value ?? '');
  }

  return template.replace(/\{([^}]+)\}/g, (match, rawKey: string) => {
    const key = String(rawKey || '').trim().toLowerCase();
    if (!lookup.has(key)) return match;
    return lookup.get(key) as string;
  });
}

export function toVariableToken(heading: string): string {
  return `{${heading}}`;
}
